import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import config from '@/config'

// 全局修复：拦截所有axios请求，在HTTPS页面上强制使用HTTPS
if (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:') {
  // 拦截axios的默认适配器，确保所有请求都使用HTTPS
  const originalAdapter = axios.defaults.adapter
  axios.defaults.adapter = function(config) {
    // 修复baseURL
    if (config.baseURL && typeof config.baseURL === 'string' && config.baseURL.startsWith('http://')) {
      config.baseURL = config.baseURL.replace('http://', 'https://')
    }
    // 修复URL
    if (config.url && typeof config.url === 'string' && config.url.startsWith('http://')) {
      config.url = config.url.replace('http://', 'https://')
    }
    // 修复协议相对URL
    if (config.url && typeof config.url === 'string' && config.url.startsWith('//')) {
      config.url = 'https:' + config.url
    }
    if (config.baseURL && typeof config.baseURL === 'string' && config.baseURL.startsWith('//')) {
      config.baseURL = 'https:' + config.baseURL
    }
    // 使用原始适配器发送请求
    return originalAdapter ? originalAdapter(config) : axios.getAdapter(['xhr'])(config)
  }
}

// 创建axios实例
// 如果页面是HTTPS，确保baseURL使用相对路径，避免混合内容错误
let baseURL = config.baseURL
if (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:') {
  // 如果baseURL是绝对HTTP URL，改为HTTPS
  if (baseURL && typeof baseURL === 'string' && baseURL.startsWith('http://')) {
    baseURL = baseURL.replace('http://', 'https://')
    console.warn(`[Request] 初始化时已将baseURL从HTTP改为HTTPS: ${baseURL}`)
  }
  // 如果baseURL是协议相对URL（//example.com），添加https:
  else if (baseURL && typeof baseURL === 'string' && baseURL.startsWith('//')) {
    baseURL = 'https:' + baseURL
    console.warn(`[Request] 初始化时已为baseURL添加HTTPS协议: ${baseURL}`)
  }
  // 如果baseURL是绝对HTTPS URL，保持不变
  // 如果baseURL是相对路径（/api），保持不变，axios会自动使用当前页面的HTTPS协议
  // 强制确保baseURL是相对路径，这样axios就会使用当前页面的HTTPS协议
  if (baseURL && typeof baseURL === 'string' && !baseURL.startsWith('/') && !baseURL.startsWith('http://') && !baseURL.startsWith('https://') && !baseURL.startsWith('//')) {
    // 如果不是相对路径也不是绝对URL，可能是配置错误，强制添加前导斜杠
    baseURL = '/' + baseURL
  }
}

const service = axios.create({
  baseURL: baseURL,
  timeout: config.timeout // 请求超时时间
})

// 获取axios的默认适配器
const getDefaultAdapter = () => {
  // axios的默认适配器会根据环境自动选择xhr或http
  const adapters = axios.defaults.adapter
  if (adapters) {
    return adapters
  }
  // 如果没有默认适配器，尝试获取xhr适配器（浏览器环境）
  if (typeof XMLHttpRequest !== 'undefined') {
    return axios.getAdapter(['xhr'])
  }
  return axios.getAdapter(['http'])
}

// 自定义适配器：在HTTPS页面上强制使用HTTPS协议
const httpsAdapter = (config) => {
  // 如果当前页面是HTTPS，强制修复所有HTTP URL
  if (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:') {
    // 修复baseURL（包括service.defaults.baseURL）
    if (config.baseURL && typeof config.baseURL === 'string' && config.baseURL.startsWith('http://')) {
      config.baseURL = config.baseURL.replace('http://', 'https://')
      console.warn(`[Request] 已强制将baseURL从HTTP改为HTTPS: ${config.baseURL}`)
    }
    if (service.defaults.baseURL && typeof service.defaults.baseURL === 'string' && service.defaults.baseURL.startsWith('http://')) {
      service.defaults.baseURL = service.defaults.baseURL.replace('http://', 'https://')
    }
    
    // 修复URL
    if (config.url && typeof config.url === 'string' && config.url.startsWith('http://')) {
      config.url = config.url.replace('http://', 'https://')
      console.warn(`[Request] 已强制将URL从HTTP改为HTTPS: ${config.url}`)
    }
    
    // 修复协议相对URL（//example.com）
    if (config.url && typeof config.url === 'string' && config.url.startsWith('//')) {
      config.url = 'https:' + config.url
    }
    if (config.baseURL && typeof config.baseURL === 'string' && config.baseURL.startsWith('//')) {
      config.baseURL = 'https:' + config.baseURL
    }
    
    // 强制确保baseURL使用相对路径，这样axios就会使用当前页面的HTTPS协议
    const currentBaseURL = config.baseURL || service.defaults.baseURL
    if (currentBaseURL && typeof currentBaseURL === 'string') {
      // 如果是绝对HTTP URL，改为HTTPS
      if (currentBaseURL.startsWith('http://')) {
        const httpsBaseURL = currentBaseURL.replace('http://', 'https://')
        config.baseURL = httpsBaseURL
        service.defaults.baseURL = httpsBaseURL
      }
      // 如果是绝对HTTPS URL，保持不变
      // 如果是相对路径（/api），保持不变，axios会自动使用当前页面的HTTPS协议
      // 如果是其他格式，强制使用相对路径
      else if (!currentBaseURL.startsWith('https://') && !currentBaseURL.startsWith('/') && !currentBaseURL.startsWith('//')) {
        config.baseURL = '/' + currentBaseURL
        service.defaults.baseURL = '/' + currentBaseURL
      }
    }
    
  }
  
  // 使用原始适配器发送请求
  const defaultAdapter = getDefaultAdapter()
  return defaultAdapter(config)
}

// 设置自定义适配器
service.defaults.adapter = httpsAdapter

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 优先从store获取token，如果store中没有，从localStorage读取（防止刷新时store未初始化）
    let token = store.getters['auth/token']
    if (!token || token.trim() === '') {
      token = localStorage.getItem('token') || ''
      // 如果从localStorage读取到token，同步到store
      if (token) {
        store.commit('auth/SET_TOKEN', token)
      }
    }
    if (token && token.trim() !== '') {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    
    // 修复混合内容问题：如果当前页面是HTTPS，强制所有请求使用HTTPS
    if (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:') {
      // 将baseURL中的http://改为https://
      if (config.baseURL && typeof config.baseURL === 'string') {
        if (config.baseURL.startsWith('http://')) {
          config.baseURL = config.baseURL.replace('http://', 'https://')
          console.warn(`[Request] 已将baseURL从HTTP改为HTTPS: ${config.baseURL}`)
        }
        // 如果是绝对URL但缺少协议，添加https://
        else if (config.baseURL.startsWith('//')) {
          config.baseURL = 'https:' + config.baseURL
          console.warn(`[Request] 已为baseURL添加HTTPS协议: ${config.baseURL}`)
        }
      }
      
      // 将url中的http://改为https://
      if (config.url && typeof config.url === 'string') {
        if (config.url.startsWith('http://')) {
          config.url = config.url.replace('http://', 'https://')
          console.warn(`[Request] 已将URL从HTTP改为HTTPS: ${config.url}`)
        }
        // 如果是绝对URL但缺少协议，添加https://
        else if (config.url.startsWith('//')) {
          config.url = 'https:' + config.url
          console.warn(`[Request] 已为URL添加HTTPS协议: ${config.url}`)
        }
      }
      
      // 如果baseURL是相对路径，确保axios实例的defaults.baseURL也使用HTTPS
      // 这可以防止axios在构建完整URL时使用错误的协议
      if (service.defaults.baseURL && typeof service.defaults.baseURL === 'string') {
        if (service.defaults.baseURL.startsWith('http://')) {
          service.defaults.baseURL = service.defaults.baseURL.replace('http://', 'https://')
        }
      }
    }
    
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response.data

    // FastAPI默认返回状态码200，检查HTTP状态码
    if (response.status >= 200 && response.status < 300) {
      // 仅当 code 是"数字类型业务码"时，才按业务码判断
      // 20000 表示成功（后端标准成功码），200 也表示成功，其他码表示错误
      if (typeof res?.code === 'number' && res.code !== 200 && res.code !== 20000) {
        Message({
          message: res.message || '请求失败',
          type: 'error',
          duration: 5 * 1000
        })

        // 401: 未授权，需要重新登录
        // 注意：不要立即清除登录状态，让调用方决定如何处理
        // 某些接口的401可能是正常的（如未登录访问需要登录的接口）
        if (res.code === 401) {
          // 只对特定的认证相关接口清除登录状态
          // 并且只有在明确是认证失败时才清除（不是网络问题）
          const url = response.config?.url || ''
          if (url.includes('/auth/user') || url.includes('/auth/heartbeat')) {
            const errorMessage = res.message || res.detail || ''
            const isAuthFailure = errorMessage.includes('token') || 
                                  errorMessage.includes('认证') || 
                                  errorMessage.includes('登录') ||
                                  errorMessage.includes('unauthorized') ||
                                  errorMessage.includes('expired') ||
                                  errorMessage === '' // 空消息也可能是认证失败
            if (isAuthFailure) {
              store.dispatch('auth/logout')
              location.reload()
            }
          }
        }

        return Promise.reject(new Error(res.message || '请求失败'))
      }

      // 返回数据：
      // - 若是标准包装 { code:number, data:any, message } 则直接返回
      // - 若是原始对象且有 data 字段，返回 data
      // - 否则直接返回原始对象（不进行额外包装）
      if (typeof res?.code === 'number') {
        return res
      }
      // 直接返回原始响应数据，不进行额外包装
      return res
    } else {
      Message({
        message: '请求失败',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error('请求失败'))
    }
  },
  error => {
    // 对响应错误做点什么
    // 对于认证相关的403/401错误，静默处理（用户未登录是正常情况）
    const isAuthError = error.config?.url?.includes('/auth/user') && (error.response?.status === 401 || error.response?.status === 403);
    const isHeartbeatError = error.config?.url?.includes('/auth/heartbeat') && (error.response?.status === 401 || error.response?.status === 403);
    
    if (!isAuthError && !isHeartbeatError) {
      console.error('🔍 [Request] Response error:', error)
    }

    let message = '网络错误'
    
    // 处理超时错误
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      message = '请求超时，请检查网络连接或稍后重试'
      if (!isAuthError && !isHeartbeatError) {
        Message({
          message,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(error)
    }
    
    if (error.response) {
      if (!isAuthError && !isHeartbeatError) {
        console.log('🔍 [Request] 响应错误详情:', {
          status: error.response.status,
          statusText: error.response.statusText,
          data: error.response.data
        })
      }
      
      // 优先显示后端返回的具体错误信息
      if (error.response.status >= 400) {
        if (error.response.data?.message) {
          message = error.response.data.message
        } else if (error.response.data?.detail) {
          // 处理422错误的detail字段（可能是数组或字符串）
          const detail = error.response.data.detail
          if (Array.isArray(detail) && detail.length > 0) {
            message = detail.map(d => d.msg || d.message || JSON.stringify(d)).join('; ')
          } else if (typeof detail === 'string') {
            message = detail
          } else {
            message = JSON.stringify(detail)
          }
          // 针对账号未审核/已禁用导致的403，统一给出更友好的提示
          const detailStr = String(error.response.data.detail || '')
          if (
            error.response.status === 403 &&
            (detailStr.includes('尚未通过管理员审核') || 
             detailStr.includes('已被禁用') ||
             detailStr.includes('未通过平台认证'))
          ) {
            message = '账号未通过平台认证，请联系管理员认证后发布'
          }
        } else {
          // 如果没有具体错误信息，则使用默认消息
          switch (error.response.status) {
        case 400:
          message = '请求错误'
          break
        case 401:
          message = '未授权，请重新登录'
          // 只对特定的认证相关接口清除登录状态
          // 并且只有在明确是认证失败时才清除（不是网络问题）
          const url = error.config?.url || ''
          if (url.includes('/auth/user') || url.includes('/auth/heartbeat')) {
            const errorMessage = error.response?.data?.message || error.response?.data?.detail || ''
            const isAuthFailure = errorMessage.includes('token') || 
                                  errorMessage.includes('认证') || 
                                  errorMessage.includes('登录') ||
                                  errorMessage.includes('unauthorized') ||
                                  errorMessage.includes('expired') ||
                                  errorMessage === '' // 空消息也可能是认证失败
            if (isAuthFailure) {
              store.dispatch('auth/logout')
            }
          }
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          if (error.config?.url?.includes('/auth/login')) {
            message = '账号未注册，请先注册'
          } else {
            message = '请求地址出错'
          }
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = `连接错误${error.response.status}`
          }
        }
      }
    } else {
      message = '连接到服务器失败'
    }
    
    // 显示错误消息
    if (error.response && (error.response.status === 400 || error.response.status === 401 || error.response.status === 403 || error.response.status === 404)) {
      // 如果是登录请求，不在这里显示错误信息，让登录页面处理
      if (error.config?.url?.includes('/auth/login')) {
        return Promise.reject(error)
      }
      
      if (!isAuthError && !isHeartbeatError) {
        Message({
          message,
          type: 'error',
          duration: 5 * 1000
        })
      }
    }

    return Promise.reject(error)
  }
)

export default service



